import { render } from "./SideNavigation.vue?vue&type=template&id=76d1b25e&scoped=true"
import script from "./SideNavigation.vue?vue&type=script&lang=js"
export * from "./SideNavigation.vue?vue&type=script&lang=js"

import "./SideNavigation.vue?vue&type=style&index=0&id=76d1b25e&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76d1b25e"]])

export default __exports__